import { createActionCreator } from "deox";
import { PURGE } from "redux-persist";

export const purge = createActionCreator(PURGE);
